













































import { Component, Vue } from 'vue-property-decorator';
import { ApiClient, apiClient } from '@/api/ApiClient';
import moment from 'moment';
import TickCross from '@/components/TickCross.vue';
import { download } from '@/utils/file';
import camelcase from 'camelcase';
import { dateRangeTodayUntilEnd } from '@/utils/helper';

@Component({
  components: {
    TickCross,
  },
})
export default class extends Vue {

  public get moment() {
    return moment;
  }

  // table filter
  public range: Date[] = dateRangeTodayUntilEnd();
  public customerId: number = null;
  public applicationId: number = null;
  public orderByColumn: string = null;
  public orderByOrder: string = null;

  // filter option
  public states: any[] = [];

  // table
  public isTableLoading = false;

  public pageSize = 100;
  public total = 0;
  public currentPage = 1;

  public data: any[] = [];
  public customers: any[] = [];
  public applications: any[] = [];

  // filter
  public get filteredApplications() {
    return this.applications
    .filter(p =>
      (!this.customerId || p.customer.id === this.customerId)
    );
  }

  public mounted() {
    this.loadData();
  }

  // filter events
  public async onFilterCustomerChange() {
    this.applicationId = null;
    await this.loadMessages();
  }


  // table events
  public async onPaginationChange() {
    await this.loadMessages();
    this.$scrollTo("#data-table");
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadMessages();
  }

  //
  private async loadData() {
    await Promise.all([
      this.loadMessages(),
      this.loadCustomers(),
      this.loadApplications(),
    ]);
  }

  private async loadCustomers() {
    const { data } = await apiClient.customers({
      take: Number.MAX_SAFE_INTEGER,
    });
    this.customers = data.data;
  }

  private async loadApplications() {
    const { data } = await apiClient.applications({
      serviceId: 2,
      take: Number.MAX_SAFE_INTEGER,
    });
    this.applications = data.data;
  }

  private async loadMessages() {
    this.isTableLoading = true;

    const { data } = await apiClient.ycloudWhatsappIncomingMessages(this.getFilter());

    this.total = data.count;
    this.data = data.data;
    this.isTableLoading = false;
  }

  private getFilter() {
    const range = this.range || [];

    return {
      take: this.pageSize,
      page: this.currentPage,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      customerId: this.customerId || undefined,
      applicationId: this.applicationId || undefined,

      from: range[0],
      to: range[1],
    };
  }

}
